import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { AiOutlineSearch } from "react-icons/ai";
import Spinner from '../../../../../components/Spinner'
import { TableWrapper, TableSection, SearchWrapper } from '../../DashBoard/dashBoardStyled'
import { Header } from '../../Reports/reportStyled'
//table
import { Table } from 'reactstrap';
import CsvDownloader from 'react-csv-downloader';
import { MdKeyboardBackspace } from "react-icons/md";
import Pagination from '@material-ui/lab/Pagination';

function PurchaseReport() {
    let history = useHistory();
    let location = useLocation();
    const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
    const [dataList, setDataList] = useState([]);
    const [finalData, setFinalData] = useState([])
    const [csvData, setCsvData] = useState([])
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [currentPurchase, setCurrentPurchase] = useState('orders')
    const [totalPrice, setTotalPrice] = useState(0)
    const [tableSearch, setTableSearch] = useState('')
    const [purchaseState, setPurchaseState] = useState({
        purchase: '',
        userType: '',
        payment: '',
        fromDate: '',
        toDate: '',
        state: '',
        city: ''
    })

    useEffect(() => {
        if (location.state !== null && location.state !== undefined) {

            let tempFilters = location.state.filters
            if (tempFilters.purchase === 'both') tempFilters.purchase = 'All Purchases'
            if (tempFilters.purchase === 'scription') tempFilters.purchase = 'Subscription'
            if (tempFilters.state === '') tempFilters.state = 'All States'
            if (tempFilters.city === '') tempFilters.city = 'All Cities'
            if (tempFilters.userType === 'all') tempFilters.userType = 'All'
            if (tempFilters.userType === 'both') tempFilters.userType = 'Both'
            if (tempFilters.userType === 'buying') tempFilters.userType = 'Post Need'
            if (tempFilters.userType === 'selling') tempFilters.userType = 'Post Inventories'
            setPurchaseState(tempFilters)

            if (location.state.purchase === 'orders') {
                let tempData, tempAssignedData, tempShippedData, tempDelieveredData, tempClaimData, tempCancelledData, tempHoldData, tempCompleteData = []
                let initialData = location.state.data?.payload?.orders || []
                tempAssignedData = initialData.filter(data => (data.assignedList !== null && data.assignedList !== undefined)).map(data => data.assignedList)
                tempShippedData = initialData.filter(data => (data.shippedList !== null && data.shippedList !== undefined)).map(data => data.shippedList)
                tempDelieveredData = initialData.filter(data => (data.delieveredList !== null && data.delieveredList !== undefined)).map(data => data.delieveredList)
                tempClaimData = initialData.filter(data => (data.claimList !== null && data.claimList !== undefined)).map(data => data.claimList)
                tempCancelledData = initialData.filter(data => (data.cancelledList !== null && data.cancelledList !== undefined)).map(data => data.cancelledList)
                tempHoldData = initialData.filter(data => (data.holdList !== null && data.holdList !== undefined)).map(data => data.holdList)
                tempCompleteData = initialData.filter(data => (data.completeList !== null && data.completeList !== undefined)).map(data => data.completeList)
                tempData = [...tempAssignedData, ...tempShippedData, ...tempDelieveredData, ...tempClaimData, ...tempCancelledData, ...tempHoldData, ...tempCompleteData]

                let tempDataFlat
                if (location.state.payment !== 'All') tempDataFlat = tempData.flat().filter(data => data.buyerInfo.paymentMethodInfo.paymentMethod === location.state.payment)
                else tempDataFlat = tempData.flat()

                let tempDataSorted = tempDataFlat.sort((a, b) => b.created - a.created)

                //set csv data
                let tempCsvData = tempDataSorted.map(val => {
                    return ({
                        PurchaseId: val.id,
                        CompanyName: val.buyerInfo.companyName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
                        City: val.buyerInfo?.address?.city?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
                        State: val.buyerInfo?.address?.state,
                        Zip: val.buyerInfo?.address?.zip,
                        FCMember: val.innerCircle ? 'Yes' : 'No',
                        Broker: val.isReselling ? 'Yes' : 'No',
                        PaymentMethod: val.buyerInfo !== null ? val.buyerInfo.paymentMethodInfo.paymentMethod : '',
                        TotalAmount: val.buyerInfo !== null ? `$${val.buyerInfo.price.productPrice?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "")}` : '',
                        PurchaseStatus: val.orderStatus
                    })
                })
                setCsvData(tempCsvData)

                if (tempData !== null) setDataList(tempDataSorted)
                //pagination
                let pageData = JSON.parse(JSON.stringify(tempDataSorted))
                setFinalData(pageData.splice(page * 10 - 10, 10))
                if (tempDataSorted.length % 10 === 0) {
                    setPageCount(tempDataSorted.length / 10)
                } else {
                    setPageCount(Math.trunc(tempDataSorted.length / 10) + 1)
                }

                let totalRevenue = tempDataSorted.reduce((acc, data) => data.buyerInfo.price.productPrice + acc, 0)
                setTotalPrice(totalRevenue?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","))
            } else if (location.state.purchase === 'scription') {
                setCurrentPurchase('sub')
                let tempData, tempActiveData, tempPendingData, tempCancelledData, tempExpiredData = []
                let initialData = location.state.data || []
                tempActiveData = initialData.filter(data => (data.activeList !== null && data.activeList !== undefined)).map(data => data.activeList).flat().map(data => ({ ...data, subStatus: 'Active' }))
                tempPendingData = initialData.filter(data => (data.pendingList !== null && data.pendingList !== undefined)).map(data => data.pendingList).flat().map(data => ({ ...data, subStatus: 'Pending' }))
                tempCancelledData = initialData.filter(data => (data.canceledList !== null && data.canceledList !== undefined)).map(data => data.canceledList).flat().map(data => ({ ...data, subStatus: 'Cancelled' }))
                tempExpiredData = initialData.filter(data => (data.expiredList !== null && data.expiredList !== undefined)).map(data => data.expiredList).flat().map(data => ({ ...data, subStatus: 'Expired' }))
                tempData = [...tempActiveData, ...tempPendingData, ...tempCancelledData, ...tempExpiredData]

                let tempDataFlat
                if (location.state.payment !== 'All') tempDataFlat = tempData.flat().filter(data => data.paymentMethodDetailsSubscriptions.paymentMethod === location.state.payment)
                else tempDataFlat = tempData.flat()

                let tempDataSorted = tempDataFlat.sort((a, b) => b.createdAt - a.createdAt)

                //set csv data
                let tempCsvData = tempDataSorted.map(val => {
                    return ({
                        PurchaseId: val.subscriptionId,
                        CompanyName: val.companyName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
                        City: val.address?.city?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
                        State: val.address?.state,
                        Zip: val.address?.zip,
                        FCMember: val.innerCircle ? 'Yes' : 'No',
                        Broker: val.isReselling ? 'Yes' : 'No',
                        PaymentMethod: val.paymentMethodDetailsSubscriptions !== null ? val.paymentMethodDetailsSubscriptions.paymentMethod : '',
                        TotalAmount: `$${val.amount?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "")}`,
                        PurchaseStatus: val.subStatus
                    })
                })
                setCsvData(tempCsvData)

                if (tempData !== null) setDataList(tempDataSorted)
                //pagination
                let pageData = JSON.parse(JSON.stringify(tempDataSorted))
                setFinalData(pageData.splice(page * 10 - 10, 10))
                if (tempDataSorted.length % 10 === 0) {
                    setPageCount(tempDataSorted.length / 10)
                } else {
                    setPageCount(Math.trunc(tempDataSorted.length / 10) + 1)
                }

                let totalRevenue = tempDataSorted.reduce((acc, data) => data.amount + acc, 0)
                setTotalPrice(totalRevenue?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","))
            } else if (location.state.purchase === 'both') {
                setCurrentPurchase('both')
                let initialOrderData = location.state.data.orders?.payload?.orders || []
                let initialSubData = location.state.data?.userSuscriptionInfo || []
                let tempDataOrd, tempDataSub = []
                let tempAssignedData, tempShippedData, tempDelieveredData, tempClaimData, tempCancelledOrderData, tempHoldData, tempCompleteData = []
                let tempActiveData, tempPendingData, tempCancelledSubData, tempExpiredData = []

                //order
                tempAssignedData = initialOrderData.filter(data => (data.assignedList !== null && data.assignedList !== undefined)).map(data => data.assignedList)
                tempShippedData = initialOrderData.filter(data => (data.shippedList !== null && data.shippedList !== undefined)).map(data => data.shippedList)
                tempDelieveredData = initialOrderData.filter(data => (data.delieveredList !== null && data.delieveredList !== undefined)).map(data => data.delieveredList)
                tempClaimData = initialOrderData.filter(data => (data.claimList !== null && data.claimList !== undefined)).map(data => data.claimList)
                tempCancelledOrderData = initialOrderData.filter(data => (data.cancelledList !== null && data.cancelledList !== undefined)).map(data => data.cancelledList)
                tempHoldData = initialOrderData.filter(data => (data.holdList !== null && data.holdList !== undefined)).map(data => data.holdList)
                tempCompleteData = initialOrderData.filter(data => (data.completeList !== null && data.completeList !== undefined)).map(data => data.completeList)

                //subscription
                tempActiveData = initialSubData.filter(data => (data.activeList !== null && data.activeList !== undefined)).map(data => data.activeList).flat().map(data => ({ ...data, subStatus: 'Active' }))
                tempPendingData = initialSubData.filter(data => (data.pendingList !== null && data.pendingList !== undefined)).map(data => data.pendingList).flat().map(data => ({ ...data, subStatus: 'Pending' }))
                tempCancelledSubData = initialSubData.filter(data => (data.canceledList !== null && data.canceledList !== undefined)).map(data => data.canceledList).flat().map(data => ({ ...data, subStatus: 'Cancelled' }))
                tempExpiredData = initialSubData.filter(data => (data.expiredList !== null && data.expiredList !== undefined)).map(data => data.expiredList).flat().map(data => ({ ...data, subStatus: 'Expired' }))

                tempDataOrd = [...tempAssignedData, ...tempShippedData, ...tempDelieveredData, ...tempClaimData, ...tempCancelledOrderData, ...tempHoldData, ...tempCompleteData]
                tempDataSub = [...tempActiveData, ...tempPendingData, ...tempCancelledSubData, ...tempExpiredData]

                let tempDataOrdFlat
                if (location.state.payment !== 'All') tempDataOrdFlat = tempDataOrd.flat().filter(data => data.buyerInfo.paymentMethodInfo.paymentMethod === location.state.payment)
                else tempDataOrdFlat = tempDataOrd.flat()

                let tempDataSubFlat
                if (location.state.payment !== 'All') tempDataSubFlat = tempDataSub.flat().filter(data => data.paymentMethodDetailsSubscriptions.paymentMethod === location.state.payment)
                else tempDataSubFlat = tempDataSub.flat()

                tempDataSubFlat = tempDataSubFlat.map(data => ({ ...data, created: data.createdAt }))

                let tempData = [...tempDataOrdFlat, ...tempDataSubFlat]

                let tempDataSorted = tempData.sort((a, b) => b.created - a.created)

                //set csv data
                let tempCsvData = tempDataSorted.map(val => {
                    if (val.amount !== undefined) {
                        return ({
                            PurchaseId: val.subscriptionId,
                            CompanyName: val.companyName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
                            City: val.address?.city?.replaceAll(","," "),
                            State: val.address?.state,
                            Zip: val.address?.zip,
                            FCMember: val.innerCircle ? 'Yes' : 'No',
                            Broker: val.isReselling ? 'Yes' : 'No',
                            PaymentMethod: val.paymentMethodDetailsSubscriptions !== null ? val.paymentMethodDetailsSubscriptions.paymentMethod : '',
                            TotalAmount: `$${val.amount?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "")}`,
                            PurchaseStatus: val.subStatus
                        })
                    } else {
                        return ({
                            PurchaseId: val.id,
                            CompanyName: val.buyerInfo.companyName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
                            City: val.buyerInfo?.address?.city?.replaceAll(","," "),
                            State: val.buyerInfo?.address?.state,
                            Zip: val.buyerInfo?.address?.zip,
                            FCMember: val.innerCircle ? 'Yes' : 'No',
                            Broker: val.isReselling ? 'Yes' : 'No',
                            PaymentMethod: val.buyerInfo !== null ? val.buyerInfo.paymentMethodInfo.paymentMethod : '',
                            TotalAmount: val.buyerInfo !== null ? `$${val.buyerInfo.price.productPrice?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "")}` : '',
                            PurchaseStatus: val.orderStatus
                        })
                    }
                })
                setCsvData(tempCsvData)

                if (tempDataSorted !== null) setDataList(tempDataSorted)
                //pagination
                let pageData = JSON.parse(JSON.stringify(tempDataSorted))
                setFinalData(pageData.splice(page * 10 - 10, 10))
                if (tempDataSorted.length % 10 === 0) {
                    setPageCount(tempDataSorted.length / 10)
                } else {
                    setPageCount(Math.trunc(tempDataSorted.length / 10) + 1)
                }

                let totalRevenue = tempDataOrdFlat.reduce((acc, data) => data.buyerInfo.price.productPrice + acc, 0)
                let totalRevenue1 = tempDataSubFlat.reduce((acc, data) => data.amount + acc, totalRevenue)
                setTotalPrice(totalRevenue1?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","))
            }
        } else {
            history.push({
                pathname: '/reports',
                state: { page: 'purchase' }
            })
        }
    }, []);

    const handleChange = (event, value) => {
        setPage(value);
        const search = tableSearch
        let dataListtemp = dataList.filter(value => {
            if (value.amount !== undefined) {
                return (
                    (value.subscriptionId !== null && value.subscriptionId.toString().toLowerCase().includes(search.toLowerCase())) ||
                    (value.companyName !== null && value.companyName.toString().toLowerCase().includes(search.toLowerCase())) ||
                    (value.amount !== null && value.amount.toString().toLowerCase().includes(search.toLowerCase())) ||
                    (value.subStatus !== null && value.subStatus.toString().toLowerCase().includes(search.toLowerCase())) ||
                    (value.paymentMethodDetailsSubscriptions.paymentMethod !== null && value.paymentMethodDetailsSubscriptions.paymentMethod.toString().toLowerCase().includes(search.toLowerCase())) ||
                    (value.address && value.address.city !== null && value.address.city.toString().toLowerCase().includes(search.toLowerCase())) ||
                    (value.address && value.address.state != null && value.address.state.toString().toLowerCase().includes(search.toLowerCase())) ||
                    (value.address && value.address.zip != null && value.address.zip.toString().toLowerCase().includes(search.toLowerCase()))
                )
            } else {
                return (
                    (value.id !== null && value.id.toString().toLowerCase().includes(search.toLowerCase())) ||
                    (value.buyerInfo.companyName && value.buyerInfo.companyName !== null && value.buyerInfo.companyName.toString().toLowerCase().includes(search.toLowerCase())) ||
                    (value.buyerInfo.paymentMethodInfo.paymentMethod !== null && value.buyerInfo.paymentMethodInfo.paymentMethod.toString().toLowerCase().includes(search.toLowerCase())) ||
                    (value.buyerInfo.price.productPrice !== null && value.buyerInfo.price.productPrice.toString().toLowerCase().includes(search.toLowerCase())) ||
                    (value.orderStatus !== null && value.orderStatus.toString().toLowerCase().includes(search.toLowerCase())) ||
                    (value.buyerInfo && value.buyerInfo.city !== null && value.buyerInfo.city.toString().toLowerCase().includes(search.toLowerCase())) ||
                    (value.buyerInfo && value.buyerInfo.state !== null && value.buyerInfo.state.toString().toLowerCase().includes(search.toLowerCase())) ||
                    (value.buyerInfo && value.buyerInfo?.address?.zip != null && value.buyerInfo?.address?.zip.toString().toLowerCase().includes(search.toLowerCase()))
                )
            }
        }
        );
        let pageData = JSON.parse(JSON.stringify(dataListtemp))
        setFinalData(pageData.splice(value * 10 - 10, 10))
    };

    let headerArr = [
        { title: 'Purchase Id', },
        { title: 'Company/Location Name', },
        { title: 'City', },
        { title: 'State', },
        { title: 'Zip', },
        { title: 'FC Member', },
        { title: 'Broker', },
        { title: 'Payment Method', },
        { title: 'Total Amount', },
        { title: 'Purchase Status', }
    ];

    //for csv download
    const columns = [
        { id: 'PurchaseId', displayName: 'Purchase Id' },
        { id: 'CompanyName', displayName: 'Company/Location Name' },
        { id: 'City', displayName: 'City' },
        { id: 'State', displayName: 'State' },
        { id: 'Zip', displayName: 'Zip' },
        { id: 'FCMember', displayName: 'FC Member' },
        { id: 'Broker', displayName: 'Broker' },
        { id: 'PaymentMethod', displayName: 'Payment Method' },
        { id: 'TotalAmount', displayName: 'Total Amount' },
        { id: 'PurchaseStatus', displayName: 'Purchase Status' }
    ]

    const csvDatafunciton=(tempDataSorted)=>{
        if (location.state.purchase === 'orders') {
            let tempCsvData = tempDataSorted.map(val => {
                return ({
                    PurchaseId: val.id,
                    CompanyName: val.buyerInfo.companyName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
                    City: val.buyerInfo?.address?.city?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
                    State: val.buyerInfo?.address?.state,
                    Zip: val.buyerInfo?.address?.zip,
                    FCMember: val.innerCircle ? 'Yes' : 'No',
                    Broker: val.isReselling ? 'Yes' : 'No',
                    PaymentMethod: val.buyerInfo !== null ? val.buyerInfo.paymentMethodInfo.paymentMethod : '',
                    TotalAmount: val.buyerInfo !== null ? `$${val.buyerInfo.price.productPrice?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "")}` : '',
                    PurchaseStatus: val.orderStatus
                })
            })
            setCsvData(tempCsvData)
        }
        else if (location.state.purchase === 'scription') {
            let tempCsvData = tempDataSorted.map(val => {
                return ({
                    PurchaseId: val.subscriptionId,
                    CompanyName: val.companyName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
                    City: val.address?.city?.replaceAll(","," "),
                    State: val.address?.state,
                    Zip: val.address?.zip,
                    FCMember: val.innerCircle ? 'Yes' : 'No',
                    Broker: val.isReselling ? 'Yes' : 'No',
                    PaymentMethod: val.paymentMethodDetailsSubscriptions !== null ? val.paymentMethodDetailsSubscriptions.paymentMethod : '',
                    TotalAmount: `$${val.amount?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "")}}`,
                    PurchaseStatus: val.subStatus
                })
            })
            setCsvData(tempCsvData)

        }
        else if (location.state.purchase === 'both') {
            let tempCsvData = tempDataSorted.map(val => {
                if (val.amount !== undefined) {
                    return ({
                        PurchaseId: val.subscriptionId,
                        CompanyName: val.companyName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
                        City: val.address?.city?.replaceAll(","," "),
                        State: val.address?.state,
                        Zip: val.address?.zip,
                        FCMember: val.innerCircle ? 'Yes' : 'No',
                        Broker: val.isReselling ? 'Yes' : 'No',
                        PaymentMethod: val.paymentMethodDetailsSubscriptions !== null ? val.paymentMethodDetailsSubscriptions.paymentMethod : '',
                        TotalAmount: `$${val.amount?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "")}`,
                        PurchaseStatus: val.subStatus
                    })
                } else {
                    return ({
                        PurchaseId: val.id,
                        CompanyName: val.buyerInfo.companyName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
                        City: val.buyerInfo?.address?.city?.replaceAll(","," "),
                        State: val.buyerInfo?.address?.state,
                        Zip: val.buyerInfo?.address?.zip,
                        FCMember: val.innerCircle ? 'Yes' : 'No',
                        Broker: val.isReselling ? 'Yes' : 'No',
                        PaymentMethod: val.buyerInfo !== null ? val.buyerInfo.paymentMethodInfo.paymentMethod : '',
                        TotalAmount: val.buyerInfo !== null ? `$${val.buyerInfo.price.productPrice?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "")}` : '',
                        PurchaseStatus: val.orderStatus
                    })
                }
            })
            setCsvData(tempCsvData)

        }
    }

    const handleSearchChange = e => {
        e.preventDefault()
        setTableSearch(e.target.value)
        const search = e.target.value
        let dataListtemp = dataList.filter(value => {
            if (value.amount !== undefined) {
                return (
                    (value.subscriptionId !== null && value.subscriptionId.toString().toLowerCase().includes(search.toLowerCase())) ||
                    (value.companyName !== null && value.companyName.toString().toLowerCase().includes(search.toLowerCase())) ||
                    (value.amount !== null && value.amount.toString().toLowerCase().includes(search.toLowerCase())) ||
                    (value.subStatus !== null && value.subStatus.toString().toLowerCase().includes(search.toLowerCase())) ||
                    (value.paymentMethodDetailsSubscriptions.paymentMethod !== null && value.paymentMethodDetailsSubscriptions.paymentMethod.toString().toLowerCase().includes(search.toLowerCase())) ||
                    (value.address && value.address.city !== null && value.address.city.toString().toLowerCase().includes(search.toLowerCase())) ||
                    (value.address && value.address.state != null && value.address.state.toString().toLowerCase().includes(search.toLowerCase())) ||
                    (value.address && value.address.zip != null && value.address.zip.toString().toLowerCase().includes(search.toLowerCase()))
                )
            } else {
                return (
                    (value.id !== null && value.id.toString().toLowerCase().includes(search.toLowerCase())) ||
                    (value.buyerInfo.companyName && value.buyerInfo.companyName !== null && value.buyerInfo.companyName.toString().toLowerCase().includes(search.toLowerCase())) ||
                    (value.buyerInfo.paymentMethodInfo.paymentMethod !== null && value.buyerInfo.paymentMethodInfo.paymentMethod.toString().toLowerCase().includes(search.toLowerCase())) ||
                    (value.buyerInfo.price.productPrice !== null && value.buyerInfo.price.productPrice.toString().toLowerCase().includes(search.toLowerCase())) ||
                    (value.orderStatus !== null && value.orderStatus.toString().toLowerCase().includes(search.toLowerCase())) ||
                    (value.buyerInfo && value.buyerInfo.city !== null && value.buyerInfo.city.toString().toLowerCase().includes(search.toLowerCase())) ||
                    (value.buyerInfo && value.buyerInfo.state !== null && value.buyerInfo.state.toString().toLowerCase().includes(search.toLowerCase())) ||
                    (value.buyerInfo && value.buyerInfo?.address?.zip !== null && value.buyerInfo?.address?.zip.toString().toLowerCase().includes(search.toLowerCase()))
                )
            }
        }
        );
        setPage(1)
         csvDatafunciton(dataListtemp)
        if (dataListtemp.length % 10 === 0) {
            setPageCount(dataListtemp.length / 10)
        } else {
            setPageCount(Math.trunc(dataListtemp.length / 10) + 1)
        }
        setFinalData(dataListtemp.splice(0, 10))
    }

    return (
        <TableWrapper>
            {loaderVisible && <Spinner />}
            <MdKeyboardBackspace style={{ width: '28px', height: '28px', position: 'relative', left: '12px', top: '8px', cursor: 'pointer' }}
                onClick={() => {
                    history.push({
                        pathname: '/reports',
                        state: { page: 'purchase' }
                    })
                }} />
            <Header>
                <div className='purchase-report-top-head'>
                    <h3>Purchase Report</h3>
                    <SearchWrapper>
                        <input style={{ border: '1px solid #87CDF1', borderRadius: '5px' }} type="text" placeholder='Search' value={tableSearch}
                            onChange={handleSearchChange} />
                        <AiOutlineSearch />
                    </SearchWrapper>
                </div>
                <div className='purchase-report-info-head'>
                    <div style={{ marginTop: '15px', lineHeight: '0.7' }}>
                        <div className='d-flex'>
                            <p className='info-label'>Purchase Type</p>
                            <p>{`${purchaseState.purchase}`}</p>
                        </div>
                        <div className='info-section-left'>
                            <div className='d-flex'>
                                <div className='d-flex'>
                                    <p className='info-label'>Payment Mode </p>
                                    <p>{`${purchaseState.payment}`}</p>                                    
                                </div>
                                <div className='d-flex'>
                                    <p className='info-label'>Date Range </p>
                                    <p>{`${purchaseState.fromDate} to ${purchaseState.toDate}`}</p>
                                </div>
                            </div>
                            <div className='d-flex'>
                                <div className='d-flex'>
                                    <p className='info-label'>Location </p>
                                    <p >{`${purchaseState.city}, ${purchaseState.state}`}</p>
                                </div>
                                <div className='d-flex'>
                                    <p className='info-label'>Load/Inventories </p>
                                    <p >{`${purchaseState.userType}`}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className='d-flex'>
                            <p className='info-label' style={{ fontSize: '18px' }}>Total Purchase </p>
                            <p style={{ fontSize: '18px' }}>{`$${totalPrice}`}</p>
                        </div>
                        <CsvDownloader
                            filename="Purchase Report"
                            columns={columns}
                            datas={csvData}>
                            <button className='export-btn'>
                                Export
                            </button>
                        </CsvDownloader>
                    </div>
                </div>
            </Header>
            <TableSection>
                <Table responsive>
                    <thead>
                        <tr>
                            {headerArr.map((items, index) => (
                                <th key={index}>{items.title}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            currentPurchase === 'orders' &&
                            finalData.map((items, index) => (
                                <tr key={index}>
                                    <td>{items.id}</td>
                                    <td>{items.buyerInfo !== null ? items.buyerInfo.companyName : ''}</td>
                                    <td>{items.buyerInfo?.address?.city}</td>
                                    <td>{items.buyerInfo?.address?.state}</td>
                                    <td>{items.buyerInfo?.address?.zip}</td>
                                    <td>{items.innerCircle ? 'Yes' : 'No'}</td>
                                    <td>{items.isReselling ? 'Yes' : 'No'}</td>
                                    <td>{items.buyerInfo !== null ? items.buyerInfo.paymentMethodInfo.paymentMethod : ''}</td>
                                    <td>{items.buyerInfo !== null ? `$${items.buyerInfo.price.productPrice?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}` : ''}</td>
                                    <td>{items.orderStatus}</td>
                                </tr>
                            ))
                        }
                        {
                            currentPurchase === 'sub' &&
                            finalData.map((items, index) => (
                                <tr key={index}>
                                    <td>{items.subscriptionId}</td>
                                    <td>{items.companyName}</td>
                                    <td>{items.address?.city}</td>
                                    <td>{items.address?.state}</td>
                                    <td>{items.address?.zip}</td>
                                    <td>{items.innerCircle ? 'Yes' : 'No'}</td>
                                    <td>{items.isReselling ? 'Yes' : 'No'}</td>
                                    <td>{items.paymentMethodDetailsSubscriptions !== null ? items.paymentMethodDetailsSubscriptions.paymentMethod : ''}</td>
                                    <td>{`$${items.amount?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`}</td>
                                    <td>{items.subStatus}</td>
                                </tr>
                            ))
                        }
                        {
                            currentPurchase === 'both' &&
                            finalData.map((items, index) => {
                                if (items.amount !== undefined) {
                                    return (
                                        <tr key={index}>
                                            <td>{items.subscriptionId}</td>
                                            <td>{items.companyName}</td>
                                            <td>{items.address?.city}</td>
                                            <td>{items.address?.state}</td>
                                            <td>{items.address?.zip}</td>
                                            <td>{items.innerCircle ? 'Yes' : 'No'}</td>
                                            <td>{items.isReselling ? 'Yes' : 'No'}</td>
                                            <td>{items.paymentMethodDetailsSubscriptions !== null ? items.paymentMethodDetailsSubscriptions.paymentMethod : ''}</td>
                                            <td>{`$${items.amount?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`}</td>
                                            <td>{items.subStatus}</td>
                                        </tr>
                                    )
                                } else {
                                    return (
                                        <tr key={index}>
                                            <td>{items.id}</td>
                                            <td>{items.buyerInfo !== null ? items.buyerInfo.companyName : ''}</td>
                                            <td>{items.buyerInfo?.address?.city}</td>
                                            <td>{items.buyerInfo?.address?.state}</td>
                                            <td>{items.buyerInfo?.address?.zip}</td>
                                            <td>{items.innerCircle ? 'Yes' : 'No'}</td>
                                            <td>{items.isReselling ? 'Yes' : 'No'}</td>
                                            <td>{items.buyerInfo !== null ? items.buyerInfo.paymentMethodInfo.paymentMethod : ''}</td>
                                            <td>{items.buyerInfo !== null ? `$${items.buyerInfo.price.productPrice?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}` : ''}</td>
                                            <td>{items.orderStatus}</td>
                                        </tr>
                                    )
                                }
                            })
                        }
                        {finalData.length === 0 &&
                            <p style={{ position: 'absolute', width: '100%', textAlign: 'center', marginTop: '30px' }}>No records found</p>
                        }
                    </tbody>
                </Table>
            </TableSection>
            {dataList.length !== 0 && <Pagination count={pageCount}
                page={page}
                onChange={handleChange} />}

        </TableWrapper>

    )
};

export default PurchaseReport;
